import React from "react";
import { Input } from "antd";
import { InputProps } from "antd/lib";
import { Icon } from "ui/icons";

export const SearchInput: React.FC<InputProps> = ({ ...rest }) => {
  return <Input {...rest} addonBefore={<Icon className="color-stroke" type="sr-search" />} />;
};
